const config = {
    sales_contract: "sales.nft"
}

export default config;
